import { observer } from "mobx-react-lite";
import { InfoOutlined } from "@mui/icons-material";
import { translationService } from "e.sic-platform.webclient/src/services/translation/TranslationService";
import DataGrid from "e.sic-platform.webclient/src/components/datatable/DataGrid";
import { PricesStorage } from "e.sic-platform.webclient/src/services/shop/PricesStorage";
import { Box, IconButton, Typography } from "@mui/material";

export const ChartInfoButton = observer(function ChartInfoButton(props: {togglePanel: () => void}) {
  return (
    <Box sx={{ position: "absolute", top: 15, right: 20, zIndex: 2 }}>
      <IconButton size="large" onClick={props.togglePanel}>
        <InfoOutlined fontSize="large" color="primary" />
      </IconButton>
    </Box>
  )
})

export const CoinPricesTable = observer(function CoinPricesTable(props: {
  pricesStorage: PricesStorage; open: boolean;
}) {

  return (
    <>
      {props.open && (
        <Box sx={{width: 550}}>
          <Typography variant="caption" sx={{ mb: 1, fontWeight: 500 }}>
            {translationService.translate("shop.table-name")}
          </Typography>
          <DataGrid
            dataGridStorage={props.pricesStorage}
            itemTypeKey=""
            noSelection
            hideTotalAmount
            insideDialog
          />
        </Box>
      )}
    </>
  );
});
